const resourceManageRouter = {
  path: "/resource",
  name: "资源管理",
  meta: { title: "资源管理", icon: "el-icon-picture-outline-round" },
  redirect: "/resource/wallpaper",
  component: () => import("../../views/resourceManage/index"),
  children: [
    {
      path: "/resource/wallpaper",
      name: "壁纸资源",
      meta: { title: "壁纸资源" },
      redirect: "/resource/wallpaper/list",
      component: () =>
        import("../../views/resourceManage/wallpaperManage/index.vue"),
      children: [
        {
          path: "/resource/wallpaper/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/resource/wallpaper", title: "资源列表" },
          component: () =>
            import("../../views/resourceManage/wallpaperManage/list")
        },
        {
          path: "/resource/wallpaper/create",
          name: "新建资源",
          hidden: true,
          meta: { activePath: "/resource/wallpaper", title: "新建资源" },
          component: () =>
            import("../../views/resourceManage/wallpaperManage/createOrEdit")
        },
        {
          path: "/resource/wallpaper/edit/:id",
          name: "编辑资源",
          hidden: true,
          meta: { activePath: "/resource/wallpaper", title: "编辑资源" },
          component: () =>
            import("../../views/resourceManage/wallpaperManage/createOrEdit")
        },
        {
          path: "/resource/wallpaper/info/:id",
          name: "查看资源",
          hidden: true,
          meta: { activePath: "/resource/wallpaper", title: "查看资源" },
          component: () =>
            import("../../views/resourceManage/wallpaperManage/info")
        }
      ]
    },
    {
      path: "/resource/designer",
      name: "设计师资源",
      meta: {
        title: "设计师资源",
      },
      redirect: "/resource/designer/list",
      component: () =>
        import("../../views/collectionManage/designerManage/index.vue"),
      children: [
        {
          path: "/resource/designer/list",
          name: "设计师列表",
          hidden: true,
          meta: {
            activePath: "/resource/designer",
            title: "设计师列表",
          },
          component: () =>
            import("../../views/collectionManage/designerManage/list.vue"),
        },
        {
          path: "/resource/designer/create",
          name: "新建设计师",
          hidden: true,
          meta: {
            activePath: "/resource/designer",
            title: "新建设计师",
            layoutBackTo: "/resource/designer/list",
            layoutBackLabel: "返回设计师列表",
          },
          component: () =>
            import("../../views/collectionManage/designerManage/createOrEdit.vue"),
        },
        {
          path: "/resource/designer/edit/:id",
          name: "编辑设计师信息",
          hidden: true,
          meta: {
            activePath: "/resource/designer",
            title: "编辑设计师信息",
            layoutBackTo: "/resource/designer/list",
            layoutBackLabel: "返回设计师列表",
          },
          component: () =>
            import("../../views/collectionManage/designerManage/createOrEdit.vue"),
        },
        {
          path: "/resource/designer/info/:id",
          name: "查看设计师信息",
          hidden: true,
          meta: {
            activePath: "/resource/designer",
            title: "查看设计师信息",
            layoutBackTo: "/resource/designer/list",
            layoutBackLabel: "返回设计师列表",
          },
          component: () =>
            import("../../views/collectionManage/designerManage/info.vue"),
        },
        {
          path: "/resource/designer/resources/:id",
          name: "设计师资源列表",
          hidden: true,
          meta: {
            activePath: "/resource/designer",
            title: "资源列表",
            layoutBackTo: "/resource/designer/list",
            layoutBackLabel: "返回设计师列表",
          },
          component: () =>
            import("../../views/collectionManage/designerManage/resources.vue"),
        },
      ],
    },
    {
      path: "/resource/tag",
      name: "标签管理",
      meta: { title: "标签管理" },
      component: () =>
        import("../../views/collectionManage/tagManage/index.vue")
    },
    {
      // main 上标签管理曾在 /collection/tag，保留旧书签可用
      path: "/collection/tag",
      redirect: "/resource/tag",
      hidden: true,
    },
    {
      path: "/resource/aiAssistant",
      name: "Ai角色资源",
      meta: { title: "Ai角色资源" },
      redirect: "/resource/aiAssistant/list",
      component: () =>
        import("../../views/resourceManage/aiAssistantManage/index.vue"),
      children: [
        {
          path: "/resource/aiAssistant/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/resource/aiAssistant", title: "资源列表" },
          component: () =>
            import("../../views/resourceManage/aiAssistantManage/list")
        },
        {
          path: "/resource/aiAssistant/create",
          name: "新建资源",
          hidden: true,
          meta: {
            activePath: "/resource/aiAssistant",
            title: "新建资源",
            layoutBackTo: "/resource/aiAssistant/list",
            layoutBackLabel: "返回列表",
          },
          component: () =>
            import("../../views/resourceManage/aiAssistantManage/createOrEdit")
        },
        {
          path: "/resource/aiAssistant/edit/:id",
          name: "编辑资源",
          hidden: true,
          meta: {
            activePath: "/resource/aiAssistant",
            title: "编辑资源",
            layoutBackTo: "/resource/aiAssistant/list",
            layoutBackLabel: "返回列表",
          },
          component: () =>
            import("../../views/resourceManage/aiAssistantManage/createOrEdit")
        },
        {
          path: "/resource/aiAssistant/info/:id",
          name: "查看资源",
          hidden: true,
          meta: {
            activePath: "/resource/aiAssistant",
            title: "查看资源",
            layoutBackTo: "/resource/aiAssistant/list",
            layoutBackLabel: "返回列表",
          },
          component: () =>
            import("../../views/resourceManage/aiAssistantManage/info")
        }
      ]
    },
    {
      path: "/resource/link",
      name: "通用资源",
      meta: {
        title: "通用资源",
        // 权限表 t_operation_platform_menu 仍登记为「链接资源」，侧栏按 name 匹配需保留别名
        menuAliases: ["链接资源"],
      },
      redirect: "/resource/link/list",
      component: () =>
        import("../../views/resourceManage/genericResourceManage/index.vue"),
      children: [
        {
          path: "/resource/link/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/resource/link", title: "资源列表" },
          component: () =>
            import("../../views/resourceManage/genericResourceManage/list")
        },
        {
          path: "/resource/link/create",
          name: "创建资源",
          hidden: true,
          meta: {
            activePath: "/resource/link",
            title: "创建资源",
            layoutBackTo: "/resource/link/list",
            layoutBackLabel: "返回列表",
          },
          component: () =>
            import("../../views/resourceManage/genericResourceManage/createOrEdit")
        },
        {
          path: "/resource/link/edit/:id",
          name: "编辑资源",
          hidden: true,
          meta: {
            activePath: "/resource/link",
            title: "编辑资源",
            layoutBackTo: "/resource/link/list",
            layoutBackLabel: "返回列表",
          },
          component: () =>
            import("../../views/resourceManage/genericResourceManage/createOrEdit")
        },
        {
          path: "/resource/link/info/:id",
          name: "查看资源",
          hidden: true,
          meta: {
            activePath: "/resource/link",
            title: "查看资源",
            layoutBackTo: "/resource/link/list",
            layoutBackLabel: "返回列表",
          },
          component: () =>
            import("../../views/resourceManage/genericResourceManage/info")
        }
      ]
    },
  ]
};
export default resourceManageRouter;
